import { createContext, useContext } from 'react';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// ============ TRANSLATIONS ============

export const translations = {
  en: {
    nav: { home: 'Home', gallery: 'Gallery', about: 'About', contact: 'Contact', admin: 'Admin' },
    hero: { title: 'Elena Candalia', subtitle: 'Oil Paintings from Italy', cta: 'View Collection' },
    featured: { title: 'Featured Works', subtitle: "A curated selection of the most recent artworks" },
    gallery: { title: 'The Collection', filter: 'Filter by', all: 'All', addToCart: 'Add to Cart', sold: 'Sold', viewDetails: 'View Details' },
    about: { title: 'About the Artist', bio: 'Elena Candalia is a talented figurative artist who has masterfully united the eternal and refined beauty of classical painting with the innovation, freshness, and dynamism of modern artistic language. Her extraordinary works constitute an authentic and fascinating bridge between two distinct eras.' },
    contact: { title: 'Get in Touch', name: 'Name', email: 'Email', subject: 'Subject', message: 'Message', send: 'Send Message', newsletter: 'Subscribe to Newsletter' },
    cart: { title: 'Your Cart', empty: 'Your cart is empty', total: 'Total', checkout: 'Proceed to Checkout', remove: 'Remove' },
    checkout: { title: 'Checkout', shipping: 'Shipping Address', payment: 'Payment Method', stripe: 'Pay with Card', paypal: 'Pay with PayPal', revolut: 'Pay with Revolut' },
    footer: { rights: 'All rights reserved', privacy: 'Privacy', terms: 'Terms', refund: 'Refund Policy' },
    common: { loading: 'Loading...', error: 'An error occurred', success: 'Success', viewAll: 'View All Works' }
  },
  it: {
    nav: { home: 'Home', gallery: 'Galleria', about: 'Chi Sono', contact: 'Contatti', admin: 'Admin' },
    hero: { title: 'Elena Candalia', subtitle: "Dipinti ad Olio dall'Italia", cta: 'Scopri la Collezione' },
    featured: { title: 'Opere in Evidenza', subtitle: "Una selezione curata delle opere più recenti" },
    gallery: { title: 'La Collezione', filter: 'Filtra per', all: 'Tutti', addToCart: 'Aggiungi al Carrello', sold: 'Venduto', viewDetails: 'Vedi Dettagli' },
    about: { title: "L'Artista", bio: "Elena Candalia è una talentuosa artista figurativa che ha saputo magistralmente unire la bellezza eterna e raffinata della pittura classica con l'innovazione, la freschezza e la dinamicità del linguaggio artistico moderno. Le sue straordinarie opere costituiscono un autentico e affascinante ponte tra due epoche distinte." },
    contact: { title: 'Contattami', name: 'Nome', email: 'Email', subject: 'Oggetto', message: 'Messaggio', send: 'Invia Messaggio', newsletter: 'Iscriviti alla Newsletter' },
    cart: { title: 'Il Tuo Carrello', empty: 'Il carrello è vuoto', total: 'Totale', checkout: 'Procedi al Pagamento', remove: 'Rimuovi' },
    checkout: { title: 'Pagamento', shipping: 'Indirizzo di Spedizione', payment: 'Metodo di Pagamento', stripe: 'Paga con Carta', paypal: 'Paga con PayPal', revolut: 'Paga con Revolut' },
    footer: { rights: 'Tutti i diritti riservati', privacy: 'Privacy', terms: 'Termini', refund: 'Politica di Rimborso' },
    common: { loading: 'Caricamento...', error: 'Si è verificato un errore', success: 'Successo', viewAll: 'Vedi Tutte le Opere' }
  }
};

// ============ CONTEXTS ============

export const LanguageContext = createContext();
export const useLanguage = () => useContext(LanguageContext);

export const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export const WatermarkContext = createContext();
export const useWatermark = () => useContext(WatermarkContext);

export const SiteSettingsContext = createContext();
export const useSiteSettings = () => useContext(SiteSettingsContext);
